// extracted by mini-css-extract-plugin
export default {"cardsRow":"cardsRow__szCV_","cardStretch":"cardStretch__Z3uWu","antCardBody":"ant-card-body__mGkYv"};